export default "__VITE_ASSET__ebc5aa01__"